import { ProfessorComment } from "@/hooks/schedules/useProfessorComments";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { MessageSquare } from "lucide-react";

interface Props {
  comments: ProfessorComment[];
  compact?: boolean;
}

export const ProfessorCommentsList = ({ comments, compact = false }: Props) => {
  if (comments.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-4">
        No hay comentarios todavía.
      </p>
    );
  }

  return (
    <div className={`space-y-3 ${compact ? "max-h-48 overflow-y-auto" : ""}`}>
      {comments.map(comment => (
        <div key={comment.id} className="flex gap-3 p-3 rounded-lg bg-muted/30 border border-border/50">
          {!compact && (
            <Avatar className="h-8 w-8 shrink-0">
              <AvatarImage src={comment.professor?.avatar_url || ""} />
              <AvatarFallback className="bg-primary/10 text-primary text-xs">
                <MessageSquare className="w-3 h-3" />
              </AvatarFallback>
            </Avatar>
          )}
          <div className="flex-1 min-w-0">
            {!compact && comment.professor && (
              <p className="text-xs font-medium text-foreground">
                {comment.professor.first_name} {comment.professor.last_name}
              </p>
            )}
            <p className={`text-sm text-foreground ${compact ? "" : "mt-1"}`}>{comment.content}</p>
            <p className="text-xs text-muted-foreground mt-1">
              {format(new Date(comment.created_at), "d MMM yyyy, HH:mm", { locale: es })}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
